// User Guide interface copy. Section content lives in the locale-specific
// userGuideTranslations.* modules; this file covers page controls and states.

const ENGLISH_UI = {
  title: 'User Guide',
  subtitle: 'Step-by-step help for using the HR Portal',
  searchPlaceholder: 'Search the guide (e.g. salary, OT, sign in, MC)...',
  allTopics: 'All Topics',
  guideCategories: 'Guide categories',
  expandAll: 'Expand all sections',
  collapseAll: 'Collapse all sections',
  noMatchingTopics: 'No matching topics',
  noResultsTitle: 'No results found',
  tryDifferentWord: 'Try a different word, or',
  clearSearch: 'clear your search',
  screenshotSoon: 'Screenshot coming soon',
  openFeature: 'Open this feature',
  englishFallbackNotice:
    'Newly added topics are shown in English until their reviewed translation is available.',
  searchResults: (count, query) =>
    `${count} ${count === 1 ? 'topic' : 'topics'} match "${query}"`,
  categories: {
    start: 'Getting Started',
    'attendance-leave': 'Attendance & Leave',
    pay: 'Pay & Claims',
    'my-info': 'My Information',
    requests: 'Requests & Self-Service',
    managers: 'For Managers',
    'role-workspaces': 'Role Workspaces',
    'about-you': 'About You',
    'settings-help': 'Settings & Help',
  },
};

const USER_GUIDE_UI_TRANSLATIONS = {
  bn: {
    title: 'ব্যবহার নির্দেশিকা',
    subtitle: 'HR Portal ব্যবহারের ধাপে ধাপে সহায়িকা',
    searchPlaceholder: 'নির্দেশিকায় খুঁজুন (যেমন: বেতন, OT, লগইন, MC)...',
    allTopics: 'সব বিষয়',
    guideCategories: 'নির্দেশিকার বিভাগ',
    expandAll: 'সব বিভাগ খুলুন',
    collapseAll: 'সব বিভাগ বন্ধ করুন',
    noMatchingTopics: 'কোনো মিল পাওয়া যায়নি',
    noResultsTitle: 'কোনো ফলাফল পাওয়া যায়নি',
    tryDifferentWord: 'অন্য শব্দ দিয়ে চেষ্টা করুন, অথবা',
    clearSearch: 'খোঁজা মুছুন',
    screenshotSoon: 'স্ক্রিনশট শীঘ্রই দেওয়া হবে',
    openFeature: 'এই সুবিধাটি খুলুন',
    englishFallbackNotice:
      'নতুন যোগ করা বিষয়গুলোর যাচাইকৃত অনুবাদ না আসা পর্যন্ত সেগুলো ইংরেজিতে দেখানো হবে।',
    searchResults: (count, query) => `${count}টি বিষয় "${query}"-এর সঙ্গে মিলেছে`,
    categories: {
      start: 'শুরু করুন',
      'attendance-leave': 'উপস্থিতি ও ছুটি',
      pay: 'বেতন ও দাবি',
      'my-info': 'আমার তথ্য',
      requests: 'অনুরোধ ও স্ব-সেবা',
      managers: 'ম্যানেজারদের জন্য',
      'role-workspaces': 'ভূমিকা-ভিত্তিক কর্মক্ষেত্র',
      'about-you': 'আপনার সম্পর্কে',
      'settings-help': 'সেটিংস ও সহায়তা',
    },
  },
  ta: {
    title: 'பயனர் வழிகாட்டி',
    subtitle: 'HR Portal-ஐ பயன்படுத்துவதற்கான படிப்படியான உதவி',
    searchPlaceholder: 'வழிகாட்டியில் தேடுங்கள் (எ.கா. சம்பளம், OT, உள்நுழைவு, MC)...',
    allTopics: 'அனைத்து தலைப்புகள்',
    guideCategories: 'வழிகாட்டி வகைகள்',
    expandAll: 'அனைத்து பகுதிகளையும் விரிவாக்கு',
    collapseAll: 'அனைத்து பகுதிகளையும் சுருக்கு',
    noMatchingTopics: 'பொருந்தும் தலைப்புகள் இல்லை',
    noResultsTitle: 'முடிவுகள் எதுவும் இல்லை',
    tryDifferentWord: 'வேறு சொல்லை முயற்சிக்கவும், அல்லது',
    clearSearch: 'தேடலை அழிக்கவும்',
    screenshotSoon: 'திரைப்பிடிப்பு விரைவில் வரும்',
    openFeature: 'இந்த அம்சத்தைத் திறக்கவும்',
    englishFallbackNotice:
      'புதிதாகச் சேர்க்கப்பட்ட தலைப்புகளின் சரிபார்க்கப்பட்ட மொழிபெயர்ப்பு கிடைக்கும் வரை அவை ஆங்கிலத்தில் காட்டப்படும்.',
    searchResults: (count, query) => `${count} தலைப்புகள் "${query}" உடன் பொருந்துகின்றன`,
    categories: {
      start: 'தொடங்குதல்',
      'attendance-leave': 'வருகை மற்றும் விடுப்பு',
      pay: 'சம்பளம் மற்றும் கோரிக்கைகள்',
      'my-info': 'எனது தகவல்',
      requests: 'கோரிக்கைகள் மற்றும் சுய சேவை',
      managers: 'மேலாளர்களுக்கு',
      'role-workspaces': 'பொறுப்பு சார்ந்த பணியிடங்கள்',
      'about-you': 'உங்களைப் பற்றி',
      'settings-help': 'அமைப்புகள் மற்றும் உதவி',
    },
  },
  my: {
    title: 'အသုံးပြုသူ လမ်းညွှန်',
    subtitle: 'HR Portal အသုံးပြုနည်း အဆင့်ဆင့် လမ်းညွှန်',
    searchPlaceholder: 'လမ်းညွှန်တွင် ရှာပါ (ဥပမာ လစာ၊ OT၊ အကောင့်ဝင်ခြင်း၊ MC)...',
    allTopics: 'အကြောင်းအရာအားလုံး',
    guideCategories: 'လမ်းညွှန် အမျိုးအစားများ',
    expandAll: 'အပိုင်းအားလုံး ဖွင့်ပါ',
    collapseAll: 'အပိုင်းအားလုံး ပိတ်ပါ',
    noMatchingTopics: 'ကိုက်ညီသော အကြောင်းအရာ မရှိပါ',
    noResultsTitle: 'ရလဒ် မတွေ့ပါ',
    tryDifferentWord: 'အခြားစကားလုံးဖြင့် ရှာပါ၊ သို့မဟုတ်',
    clearSearch: 'ရှာဖွေမှုကို ရှင်းပါ',
    screenshotSoon: 'မျက်နှာပြင်ပုံ မကြာမီ ရရှိပါမည်',
    openFeature: 'ဤလုပ်ဆောင်ချက်ကို ဖွင့်ပါ',
    englishFallbackNotice:
      'အသစ်ထည့်သွင်းထားသော အကြောင်းအရာများ၏ စစ်ဆေးပြီး ဘာသာပြန်ဆိုမှု မရရှိသေးမီ အင်္ဂလိပ်ဘာသာဖြင့် ပြသပါမည်။',
    searchResults: (count, query) => `"${query}" နှင့် ကိုက်ညီသော အကြောင်းအရာ ${count} ခု`,
    categories: {
      start: 'စတင်အသုံးပြုခြင်း',
      'attendance-leave': 'တက်ရောက်မှုနှင့် ခွင့်',
      pay: 'လစာနှင့် တောင်းခံမှုများ',
      'my-info': 'ကျွန်ုပ်၏ အချက်အလက်',
      requests: 'တောင်းဆိုမှုနှင့် ကိုယ်တိုင်ဝန်ဆောင်မှု',
      managers: 'မန်နေဂျာများအတွက်',
      'role-workspaces': 'အခန်းကဏ္ဍအလိုက် လုပ်ငန်းခွင်များ',
      'about-you': 'သင့်အကြောင်း',
      'settings-help': 'ဆက်တင်နှင့် အကူအညီ',
    },
  },
};

export const getUserGuideUi = (locale) => {
  const translation = USER_GUIDE_UI_TRANSLATIONS[locale] || {};
  return {
    ...ENGLISH_UI,
    ...translation,
    categories: {
      ...ENGLISH_UI.categories,
      ...(translation.categories || {}),
    },
  };
};
